import React from 'react'
import PropTypes from 'prop-types'
import { OverlayTrigger, Tooltip } from 'react-bootstrap'

import { TopicMetricsPropType } from '../../selectors'
import * as TLM from '../../constants/tlm'

import './TopLevelMetric.scss'

/* Renders a table of top level metrics
 *
 * This is a table with a header row (of text) and rows of progress-bar style lines with a label and
 * colored bar with a number over it.
 */
export default class TopLevelMetric extends React.Component {
  static propTypes = {
    title: PropTypes.string.isRequired,
    leftColor: PropTypes.string,
    leftNegativeColor: PropTypes.string,
    rightColor: PropTypes.string,
    rightNegativeColor: PropTypes.string,
    leftGradientColor: PropTypes.string,
    rightGradientColor: PropTypes.string,
    color: PropTypes.string,
    negativeColor: PropTypes.string,
    gradientColor: PropTypes.string,
    compare: PropTypes.bool,
    data: TopicMetricsPropType.isRequired,
    dataType: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    selected: PropTypes.array.isRequired,
    // These all have defaults across all of our TLM's
    backgroundColor1: PropTypes.string.isRequired,
    backgroundColor2: PropTypes.string.isRequired,
    swappableChannel: PropTypes.string,
    isAdmin: PropTypes.bool.isRequired,
    shortcut: PropTypes.shape({
      id: PropTypes.string.isRequired,
      expires_at: PropTypes.string.isRequired
    }),
    streamingSelectedPage: PropTypes.number,
    channelSelectedPage: PropTypes.number,
    genreSelectedPage: PropTypes.number,
    brandSelectedPage: PropTypes.number,
    handlePagination: PropTypes.func
  }

  static defaultProps = {
    backgroundColor1: '#F1F2F2',
    backgroundColor2: '#E6E7E8'
  }

  constructor (props) {
    super(props)
    this.styles = {
      commonBarStyle: {
        float: 'left',
        // Use lineHeight to center text vertically and give it some padding.
        height: 25,
        lineHeight: 1.8,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        fontSize: '14px'
      },
      compareBarStyle: {
        float: 'left',
        // Use lineHeight to center text vertically and give it some padding.
        // height: 30,
        fontWeight: 600,
        whiteSpace: 'nowrap',
        fontSize: '14px'
      },
      beta: {
        color: '#A9A9A9',
        display: 'inline'
      }
    }
  }

  render () {
    const totalPages = this.props.dataType === TLM.TLM_BRAND ? Math.ceil(this.props.data.length / TLM.BRAND_TLM_PAGE_SIZE) : Math.ceil(this.props.data.length / TLM.TLM_PAGE_SIZE)
    let metricsData = this.props.data
      if (totalPages === 1) {
      metricsData = this.props.data
    } else if (totalPages > 1) {
      const start = this.props.dataType === TLM.TLM_STREAMING ? (this.props.streamingSelectedPage - 1) * TLM.TLM_PAGE_SIZE
      : this.props.dataType === TLM.TLM_CHANNEL ? (this.props.channelSelectedPage - 1) * TLM.TLM_PAGE_SIZE
      : this.props.dataType === TLM.TLM_GENRE ? (this.props.genreSelectedPage - 1) * TLM.TLM_PAGE_SIZE
      : this.props.dataType === TLM.TLM_BRAND ? (this.props.brandSelectedPage - 1) * TLM.BRAND_TLM_PAGE_SIZE
      : TLM.TLM_PAGE_SIZE
      const end = start + (this.props.dataType === TLM.TLM_BRAND ? TLM.BRAND_TLM_PAGE_SIZE :TLM.TLM_PAGE_SIZE)
      metricsData = this.props.data.slice(start, end)
    }

    const rows = metricsData.map((row, index) => {
      let { name = null } = row
      var { value } = row
      value = value.toFixed(2)
      const barStyle = {
        backgroundColor: this.props.backgroundColor1
      }
      if (index % 2 === 0) {
        barStyle.backgroundColor = this.props.backgroundColor2
      }
      const click = () => this.props.onClick(name, this.props.dataType)
      const selectedClassName = this.props.selected.indexOf(name) > -1 ? ' topMetric__chartrow--onSelect' : ''
      const selectedBarClassName = this.props.selected.indexOf(name) > -1 ? ' topMetric__chartrow__barcontainer' : 'topMetric__chartrow__barcontainer'
      const topMetricchartrow = 'topMetric__chartrow'
      const displayName = name.length > 13 ? name.substring(0, 12) + '...' : name
      return (
        <div key={name} onClick={click} className={`${topMetricchartrow} ${selectedClassName}`}>
          <div className='topMetric__chartrow__label'>{this.nameWithTooltip(name, displayName)}</div>
          <div className='topMetric__chartrow__spacer'></div>
          <div className={`${selectedBarClassName}`} style={barStyle}>
            {this.renderBar(value)}
          </div>
        </div>
      )
    })

    const toggleArrowsPagination = (dataType, type) => {
      let selectedPage = TLM.TLM_FIRST_PAGE
      switch (dataType) {
        case TLM.TLM_STREAMING:
          if (type === TLM.TLM_LEFT) {
            selectedPage = this.props.streamingSelectedPage === TLM.TLM_FIRST_PAGE ? totalPages : this.props.streamingSelectedPage - TLM.TLM_LIMIT
          } else if (type === TLM.TLM_RIGHT) {
            selectedPage = this.props.streamingSelectedPage === totalPages ? TLM.TLM_FIRST_PAGE : this.props.streamingSelectedPage + TLM.TLM_LIMIT
          }
          break
        case TLM.TLM_CHANNEL:
          if (type === TLM.TLM_LEFT) {
            selectedPage = this.props.channelSelectedPage === TLM.TLM_FIRST_PAGE ? totalPages : this.props.channelSelectedPage - TLM.TLM_LIMIT
          } else if (type === TLM.TLM_RIGHT) {
            selectedPage = this.props.channelSelectedPage === totalPages ? TLM.TLM_FIRST_PAGE : this.props.channelSelectedPage + TLM.TLM_LIMIT
          }
          break
        case TLM.TLM_GENRE:
          if (type === TLM.TLM_LEFT) {
            selectedPage = this.props.genreSelectedPage === TLM.TLM_FIRST_PAGE ? totalPages : this.props.genreSelectedPage - TLM.TLM_LIMIT
          } else if (type === TLM.TLM_RIGHT) {
            selectedPage = this.props.genreSelectedPage === totalPages ? TLM.TLM_FIRST_PAGE : this.props.genreSelectedPage + TLM.TLM_LIMIT
          }
          break
        case TLM.TLM_BRAND:
          if (type === TLM.TLM_LEFT) {
            selectedPage = this.props.brandSelectedPage === TLM.TLM_FIRST_PAGE ? totalPages : this.props.brandSelectedPage - TLM.TLM_LIMIT
          } else if (type === TLM.TLM_RIGHT) {
            selectedPage = this.props.brandSelectedPage === totalPages ? TLM.TLM_FIRST_PAGE : this.props.brandSelectedPage + TLM.TLM_LIMIT
          }
          break
        default:
          break
      }
      this.props.handlePagination(dataType, selectedPage)
    }

    const toggleCarouselPagination = (dataType, page) => {
      this.props.handlePagination(dataType, page)
    }

    return (
      <>
        <div className='topMetric'>
          <div className='topMetric__header'>
            <div>
              <OverlayTrigger overlay={this.popOver(this.props.title, this.props.dataType)} placement='top'>
                <span className="txt">{this.props.title}</span>
              </OverlayTrigger>
            </div>
            {(this.props.dataType === TLM.TLM_STREAMING || this.props.dataType === TLM.TLM_CHANNEL || this.props.dataType === TLM.TLM_GENRE || this.props.dataType === TLM.TLM_BRAND) &&
              <div>
                <span className='hover-icn' onClick={() => toggleArrowsPagination(this.props.dataType, TLM.TLM_LEFT)}>
                  <img alt='' style={{width: '13px', marginLeft: '-2px'}} src={'/static/images/arrowLeft.svg'}/>
                </span>
                <span className='hover-icn' onClick={() => toggleArrowsPagination(this.props.dataType, TLM.TLM_RIGHT)}>
                  <img alt='' style={{width: '13px'}} src={'/static/images/arrow.svg'}/>
                </span>
              </div>
            }
          </div>
          <div className={this.props.dataType === TLM.TLM_BRAND ? 'topMetric__chartcontainerBrand' : 'topMetric__chartcontainer'}>
            {rows}
          </div>
        </div>
        {(this.props.dataType === TLM.TLM_STREAMING || this.props.dataType === TLM.TLM_CHANNEL || this.props.dataType === TLM.TLM_GENRE || this.props.dataType === TLM.TLM_BRAND) &&
          <div className="paginationContainer">
            <div className="paginationContainer__spacer"></div>
            <ul className="paginationContainer__carouselIndicators">
              {
                [...Array(totalPages)].map((row, index) => {
                  const selected = ((this.props.dataType === TLM.TLM_STREAMING && index === this.props.streamingSelectedPage - TLM.TLM_LIMIT) ||
                  (this.props.dataType === TLM.TLM_CHANNEL && index === this.props.channelSelectedPage - TLM.TLM_LIMIT)) ||
                  (this.props.dataType === TLM.TLM_GENRE && index === this.props.genreSelectedPage - TLM.TLM_LIMIT) ||
                  (this.props.dataType === TLM.TLM_BRAND && index === this.props.brandSelectedPage - TLM.TLM_LIMIT) ? true : false
                  return (
                    <li key={index} className={selected ? 'paginationContainer__carouselIndicators--active' : ''} onClick={() => toggleCarouselPagination(this.props.dataType, index + TLM.TLM_LIMIT)}></li>
                  )
                })
              }
            </ul>
          </div>
        }
      </>
    )
  }

  nameWithTooltip (name, displayName) {
    if (name.length > 13) {
      return (
        <OverlayTrigger overlay={(<Tooltip id="title">{name}</Tooltip>)} placement="bottom">
          <span>{displayName}</span>
        </OverlayTrigger>
      )
    }
    return displayName
  }

  popOver (title, type) {
    let text = ''
    switch (title) {
      case 'Content Preference':
        text = type === TLM.TLM_VPP ?
        'This audience talks about content produced by network, linear or streaming platforms X percent above or below average.'
        : 'This audience talks about content produced by brands X percent above or below average.'
        break
      case 'Entity Type Preference':
        text = 'This audience talks about Shows, Movies, Sports, Music, People entities X percent above or below average.'
        break
      case 'Streaming Preference':
        text = 'This audience talks about content produced by Hulu, Netflix and Amazon X percent above or below average.'
        break
      case 'Broadcast Preference':
        text = 'This audience talks about content produced by ABC, CBS, NBC, FOX and the CW X percent above or below average.'
        break
      case 'Network Preference':
        text = 'This audience talks about content produced by the listed networks X percent above or below average.'
        break
      case 'Genre Preference':
          text = 'This audience talks about content produced by the listed genres X percent above or below average.'
          break
      case 'Category Preference':
        text = 'This audience talks about content produced by the listed brands X percent above or below average.'
        break
      default:
        break
    }
    return <Tooltip id='BETA'>{text}</Tooltip>
  }

  renderBar (value) {
    const barStyle = {
      height: '100%',
      overflow: 'hidden'
    }
    let elements = this.renderNegative(value)
    elements = elements.concat(this.renderPositive(value))
    return (
      <div style={barStyle}>
        {elements}
      </div>
    )
  }

  renderNegative (value, entity) {
    const compare = (this.props.compare === true)
    if (value >= 0) {
      const style = {
        ...this.styles.commonBarStyle,
        width: '50%'
      }
      const compareStyle = {
        ...this.styles.compareBarStyle,
        width: '50%'
      }
      return [
        <span key='negativePadding' style={compare ? compareStyle : style}>&nbsp;</span>
      ]
    }

    // Always round up to the next whole percentage.
    const negativeBarWidthPercent = Math.ceil(50 * Math.min(Math.abs(value), 1.0))
    const negativePaddingWidthPercent = 50 - negativeBarWidthPercent
    const paddingStyle = {
      ...this.styles.commonBarStyle,
      width: `${negativePaddingWidthPercent}%`
    }
    const comparePaddingStyle = {
      ...this.styles.compareBarStyle,
      width: `${negativePaddingWidthPercent}%`
    }

    const valueStyle = {
      ...this.styles.commonBarStyle,
      width: `${negativeBarWidthPercent}%`,
      color: `rgb(${this.props.color})`,
      backgroundColor: `rgb(${this.props.negativeColor})`,
      textAlign: 'right',
      paddingRight: 5,
      direction: 'rtl' // Render text right to left...requires we invert the text
    }
    const compareValueStyle = {
      ...this.styles.compareBarStyle,
      width: `${negativeBarWidthPercent}%`,
      color: `rgb(${entity==='leftEntity' ? this.props.leftColor : this.props.rightColor})`,
      backgroundColor: `rgb(${entity==='leftEntity' ? this.props.leftNegativeColor : this.props.rightNegativeColor})`,
      textAlign: 'right',
      paddingRight: 5,
      direction: 'rtl' // Render text right to left...requires we invert the text
    }
    let text = `${(value * -100).toFixed(0)}%-`
    let elements = [
      (<span key='negativePadding' style={compare ? comparePaddingStyle : paddingStyle}>&nbsp;</span>),
      (<span key='negativeValue' style={compare ? compareValueStyle : valueStyle}>{text}</span>)
    ]

    return elements
  }

  renderPositive (value, entity) {
    const compare = (this.props.compare === true)
    if (value < 0) {
      return []
    }

    let elements = []
    const widthPercent = 50 * Math.min(value, 1.0)
    let text = `${(value * 100).toFixed(0)}%`
    let positiveValue = (value * 100).toFixed(0)
    let bgColorGradient = positiveValue > 100 ? this.props.gradientColor : `rgb(${this.props.color})`
    let compareBgColorGradient = positiveValue > 100 ?
      `${entity==='leftEntity' ? this.props.leftGradientColor : this.props.rightGradientColor}`
      :
      `rgb(${entity==='leftEntity' ? this.props.leftNegativeColor : this.props.rightNegativeColor})`
    // Special case 0
    if (value > 0) {
      const style = {
        ...this.styles.commonBarStyle,
        width: `${widthPercent}%`,
        color: `rgb(${this.props.negativeColor})`,
        backgroundColor: `rgb(${this.props.color})`,
        textAlign: 'left',
        paddingLeft: 5
      }
      const compareStyle = {
        ...this.styles.compareBarStyle,
        width: `${widthPercent}%`,
        color: `rgb(${entity==='leftEntity' ? this.props.leftNegativeColor : this.props.rightNegativeColor})`,
        backgroundColor: `rgb(${entity==='leftEntity' ? this.props.leftColor : this.props.rightColor})`,
        textAlign: 'left',
        paddingLeft: 5
      }
      let barText = (<span>&nbsp;</span>)
      if (value > 0.3) {
        barText = text
      }
      elements.push(
        <span key='positiveValue' className={compare ? compareBgColorGradient : bgColorGradient} style={compare ? compareStyle : style}>{barText}</span>
      )
    }
    // For small values, render the label outside the bar.
    if (value <= 0.3) {
      const style = {
        ...this.styles.commonBarStyle,
        color: `rgb(${this.props.color})`,
        textAlign: 'left',
        paddingLeft: 5
      }
      const compareStyle = {
        ...this.styles.compareBarStyle,
        color: `rgb(${entity==='leftEntity' ? this.props.leftColor : this.props.rightColor})`,
        textAlign: 'left',
        paddingLeft: 5
      }
      elements.push(
        <span key='positiveText' style={compare ? compareStyle : style}>{text}</span>
      )
    }

    return elements
  }
}
